import ServiceTemplate from './ServiceTemplate';

const BPH = () => {
  const data = {
    title: 'Enlarged Prostate (BPH)',
    tagline: 'Relief From Urinary Symptoms.',
    description: 'Benign Prostatic Hyperplasia (BPH) is a common condition affecting urinary function in men, especially those over 50. Treatment can significantly improve quality of life.',
    causesTitle: 'Common BPH Symptoms',
    causes: [
      'Frequent urination, especially at night',
      'Weak or interrupted urine stream',
      'Difficulty starting urination',
      'Feeling of incomplete bladder emptying',
      'Urgency to urinate',
      'Straining while urinating',
    ],
    symptoms: [
      'Waking multiple times at night to urinate',
      'Weak urine flow',
      'Hesitancy when starting',
      'Dribbling after urination',
      'Sudden urge to urinate',
    ],
    treatments: [
      'Medications to relax the prostate',
      'Medications to shrink the prostate',
      'Minimally invasive procedures (UroLift, Rezum)',
      'Surgical options for severe cases',
    ],
    faqs: [
      { q: 'Is BPH the same as prostate cancer?', a: 'No, BPH is a benign (non-cancerous) enlargement of the prostate. However, symptoms can overlap, so proper evaluation is important.' },
      { q: 'Do I need surgery for BPH?', a: 'Many men find relief with medications or minimally invasive procedures. Surgery is typically reserved for severe cases or when other treatments are ineffective.' },
      { q: 'Will BPH symptoms get worse over time?', a: 'Without treatment, symptoms often progress. Early intervention can help manage symptoms and prevent complications.' },
    ],
    cta: 'Find relief today.',
    seoTitle: 'Enlarged Prostate (BPH) Treatment Melbourne FL',
    seoDescription: 'BPH treatment in Melbourne, FL. Dr. Havkin provides evaluation and treatment for enlarged prostate symptoms including medications and minimally invasive procedures.',
    seoKeywords: 'BPH treatment Melbourne FL, enlarged prostate doctor, prostate treatment, urinary symptoms treatment, benign prostatic hyperplasia',
    seoCanonical: '/services/bph',
  };

  return <ServiceTemplate {...data} />;
};

export default BPH;
